import type { ReactNode } from 'react';
import { Button } from 'antd';

// Inline "שכפול" panel shared by the rate / class-bonus editors: pick more
// targets (the fields are the caller's), see how many rows that makes, apply.
// A target that already has a setting is overwritten, never duplicated.

export function DuplicatePanel({
  children,
  added,
  replaced,
  onApply,
  onCancel,
}: {
  children: ReactNode;
  added: number;
  replaced: number;
  onApply: () => void;
  onCancel: () => void;
}) {
  const parts = [added > 0 && `ייווספו ${added}`, replaced > 0 && `יעודכנו ${replaced} קיימים`].filter(Boolean);
  return (
    <div className="bg-grey-bg border rounded px-3 py-2 mt-2">
      <div className="text-small text-secondary-text mb-2">
        שכפול אותה הגדרה (אותם סכומים ומדרגות) לפריטים נוספים. פריט שכבר מוגדר לו תעריף יעודכן להגדרה הזו.
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
      <div className="flex items-center gap-2 mt-2">
        <Button size="small" type="primary" disabled={added + replaced === 0} onClick={onApply}>
          שכפל
        </Button>
        <Button size="small" onClick={onCancel}>
          ביטול
        </Button>
        <span className="text-small text-secondary-text">{parts.length ? parts.join(' · ') : 'בחרו לאן לשכפל'}</span>
      </div>
    </div>
  );
}
